import { useTranslation } from "react-i18next";

const TermCard = ({ term }) => {
  const { t } = useTranslation();
  return (
    <div className="my-5 overflow-hidden bg-white rounded-2xl shadow-mainShadow">
      <img className="h-[420px] w-full object-fill" src={term.img} alt={term.name} />
      <div className="p-5 space-y-4">
        <h2 className="text-2xl font-bold">{t(term.name)}</h2>
        <section>
          <h3 className="text-mainRed">{t("cost")}</h3>
          <p>{t(term.cost)}</p>
        </section>
        <section>
          <h3 className="text-mainRed">
            {t("risks")}
            <span>{term.insurance ? t("insurance-") : ""}:</span>
          </h3>
          <p>{t(term.risks)}</p>
        </section>
      </div>
    </div>
  );
};

export default TermCard;
